<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<table>
			<tr>
				<td colspan="1" style="text-align: right;">
					<h2><br><br>Occupancy</h2>
				</td>
			</tr>
			<tr>
				<td></td>
				<td style="text-align: right;"><b>Per Night</b></td>
				<td style="text-align: right;" class="p-ml-6"><b>Total</b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Total : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Guest : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsGuestAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsGuestTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Owner : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsOwnerAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsOwnerTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Owner Guest : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsOwnerGuestAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsOwnerGuestTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Not Avail : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsNotAvailAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsNotAvailTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Hold : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsHoldAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsHoldTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Hold Expire : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsHoldExpireAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsHoldExpireTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Guest Cancel : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsGuestCancelAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsGuestCancelTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Owner Cancel : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsOwnerCancelAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsOwnerCancelTTL}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Owner Guest Cancel : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsOwnerGuestCancelAVG}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsOwnerGuestCancelTTL}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;"> # Nights Postpone : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.numNightsPostponeAVG}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.numNightsPostponeTTL}} </b></td>
			</tr>
		</table>
	</div>
	<div class="p-col-12 p-md-6 p-pl-6">
		<table>
			<tr>
				<td colspan="1" style="text-align: right;">
					<h2><br><br>Revenue</h2>
				</td>
			</tr>
			<tr>
				<td></td>
				<td style="text-align: right;"><b>Per Night</b></td>
				<td style="text-align: right;" class="p-ml-6"><b>Total</b></td>
			</tr>
			<tr>
				<td style="text-align: right;">Adjustment: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revAdjustmentAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revAdjustmentTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">FreeCar: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revFreeCarAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revFreeCarTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">FreeRent: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revFreeRentAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revFreeRentTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">RoomRateGross: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revRoomRateGrossAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revRoomRateGrossTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">RoomRateNet: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revRoomRateNetAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revRoomRateNetTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">Housekeeping: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revHousekeepingAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revHousekeepingTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">LateCheckOut: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revLateCheckOutAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revLateCheckOutTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">Occupancy: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revOccupancyAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revOccupancyTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">Resort: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revResortAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revResortTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">TravelIns: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revTravelInsAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revTravelInsTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">TravelInsPrem: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revTravelInsPremAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revTravelInsPremTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">DamageWaiver: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revDamageWaiverAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revDamageWaiverTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">DamageWaiverPrem: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revDamageWaiverPremAVG | currency}}</b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revDamageWaiverPremTTL | currency}}
					</b></td>
			</tr>
			<tr>
				<td style="text-align: right;">CreditCard: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revCreditCardAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revCreditCardTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">Cancel: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revCancelAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revCancelTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">Rollaway: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revRollawayAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revRollawayTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">Pet: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revPetAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revPetTTL | currency}} </b></td>
			</tr>
			<tr>
				<td style="text-align: right;">Commission: </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revCommissionAVG | currency}} </b>
				</td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revCommissionTTL | currency}} </b>
				</td>
			</tr>
			<tr>
				<td style="text-align: right;">Revenue : </td>
				<td class="p-ml-3" style="text-align: right;"><b> {{resRevenue.revMgrAVG | currency}} </b></td>
				<td class="p-pl-5" style="text-align: right;"><b> {{resRevenue.revMgrTTL | currency}} </b></td>
			</tr>
		</table>
	</div>
</div>